import { useMemo } from "react";
import { useDietData } from "../providers/DietDataProvider";
import { computeMealStructureNutrition } from "./calculateMealNutrients";

/**
 * Instant nutrition summary for unsaved / filtered meal trees (frontend only).
 * Persisted plan/template data should use nutrition_summary from fetch APIs.
 */
export function useMealStructureNutrition(meals, { enabled = true } = {}) {
  const { dietCommonUtils } = useDietData();

  const nutritionSummary = useMemo(() => {
    if (!enabled || !meals?.length) return null;
    return computeMealStructureNutrition(meals, dietCommonUtils || {});
  }, [meals, enabled, dietCommonUtils]);

  return { nutritionSummary, loading: false };
}
